module.exports = __webpack_public_path__ + "img/Skirt-Back-B7-Da-Fb-Hc.fd77150e.png";